import { render, staticRenderFns } from "./CodProductList.vue?vue&type=template&id=696074a7&"
import script from "./CodProductList.vue?vue&type=script&lang=js&"
export * from "./CodProductList.vue?vue&type=script&lang=js&"
import style0 from "./CodProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports